module.exports = __webpack_public_path__ + "media/components/helpcenter/InsightsHelp/InsightStep2-6d7fef8a1fe68856f3095af382c3e87f.jpg";